import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnUM: CultureInfo = {
  name: 'en-UM',
  displayName: 'English (U.S. Outlying Islands)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-UM',
  parent: CultureInfoEn
};
